/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Table_Reset_FiltersInputs */

const en_table_reset_filters = /** @type {(inputs: Table_Reset_FiltersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reset filters`)
};

const es_table_reset_filters = /** @type {(inputs: Table_Reset_FiltersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Restablecer filtros`)
};

/**
* | output |
* | --- |
* | "Reset filters" |
*
* @param {Table_Reset_FiltersInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const table_reset_filters = /** @type {((inputs?: Table_Reset_FiltersInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Table_Reset_FiltersInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_table_reset_filters(inputs)
	return es_table_reset_filters(inputs)
});